
import { useTranslations } from "use-intl";
import { ExternalLink, LogOut } from "lucide-react";
import { Link } from "@/i18n/navigation";
import { useLogout } from "@/features/auth/hooks/use-logout";
import { Button } from "@/components/ui/button";
import { LocaleSwitcher } from "@/components/shared/locale-switcher";
import { LogoMark } from "@/components/shared/logo-mark";
import { ThemeToggle } from "@/components/shared/theme-toggle";

export function AdminHeader({ displayName, email }: { displayName: string; email: string }) {
  const t = useTranslations("admin");
  const tc = useTranslations("common");
  const handleLogout = useLogout("/login");

  return (
    <header className="flex h-16 items-center justify-between border-b border-border bg-background px-4 sm:px-6">
      <Link
        href="/"
        className="flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground lg:hidden"
      >
        <LogoMark className="h-6 w-6" />
      </Link>

      <Link
        href="/"
        className="hidden items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground lg:flex"
      >
        <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
        {t("header.backToSite")}
      </Link>

      <div className="flex items-center gap-3">
        <ThemeToggle />
        <LocaleSwitcher />
        <div className="hidden flex-col items-end text-right sm:flex">
          <span className="text-sm font-medium leading-tight">{displayName}</span>
          <span className="text-xs text-muted-foreground leading-tight">{email}</span>
        </div>
        <Button variant="ghost" size="sm" onClick={handleLogout} aria-label={tc("nav.logout")}>
          <LogOut className="h-4 w-4" aria-hidden="true" />
        </Button>
      </div>
    </header>
  );
}
